import { FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { EmailType, EventType } from '../../../../../models';
import { UnderContractEmailModal } from '../../../under-contract/under-contract-details/send-email/under-contract-email-modal';
import { Button } from '../../../../../components';

interface IClosingDetails {
  statusText?: string;
}

export const ClosingDetails: FC<IClosingDetails> = ({ statusText }) => {
  const classes = useStyles();
  const { buildId }: { buildId: string } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setisLoading] = useState(false);

  return (
    <>
      <Grid container>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.readOnlyHeaders} variant="h6">
            Build Info
          </Typography>
          <Typography variant="subtitle1" className={classes.statusText}>
            <span className={classes.detailsLabel}>Status:</span> {statusText} <br />
          </Typography>
          <Typography variant="subtitle1">
            <span className={classes.detailsLabel}>Final Contract Accepted</span> <br />
            This contract has been accepted. <br />
            The build is now in closing status and the appropriate closing documents have been
            generated.
          </Typography>
          <Button
            variant={'contained'}
            color="secondary"
            onClick={() => setIsModalOpen(true)}
            id={'SendContractNotification'}
          >
            Send Contract Notification
          </Button>
        </Grid>
      </Grid>
      <UnderContractEmailModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        setIsLoading={() => setisLoading(false)}
        isLoading={isLoading}
        buildId={buildId}
        emailType={EmailType.FinalContractNotification}
        eventType={EventType.FinalContractNotification}
      />
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  readOnlyHeaders: {
    paddingBottom: theme.spacing(0.25),
    fontWeight: '700'
  },
  detailsLabel: {
    fontWeight: 'bold'
  },
  statusText: {
    paddingBottom: '8px'
  }
}));
